import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField, ghgCategoryField } from './common/sharedFields';
import { msg } from '@lingui/core/macro';

export const ceePrecalculatedMetadata = {
  displayName: msg({
    message: 'CEE Precalculated',
    context: 'Activity data schema name for CEE Precalculated',
  }),
  fields: {
    ...coreFields,
    ghg_category_id: ghgCategoryField,
    allocation_location_quantity_kg_co2e: {
      displayName: msg({
        message: 'Allocation location quantity',
        context: 'The allocation location quantity in kgCO2e.',
      }),
    },
    is_override: {
      displayName: msg({
        message: 'Is override',
        context: 'Whether the precalculated emissions are an override.',
      }),
    },
    quantity: {
      displayName: msg({
        message: 'Pre-calculated emissions',
        context: 'The pre-calculated kgCO2e.',
      }),
      externalDescription: msg({
        message: 'The pre-calculated emissions.',
        context: 'Pre-calculated kgCO2e.',
      }),
    },
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
